<template>
    <tbody class="table-body">
        <slot />
    </tbody>
</template>

<script lang="ts">
export default {
    name: "TableBody",
};
</script>

<style>
@import "@/style/data-tables.css";
</style>
